import { Injectable } from '@angular/core';
import { HttpService} from "../../../services/http.service";

const BaseURL: string = 'join_duplicate_customers/';

@Injectable({
    providedIn: 'root'
})
export class JoinDuplicateCustomersService {
    constructor(private HttpService: HttpService) {}

    joinDuplicate(customer_id: number, duplicate_id: number) {
        return this.HttpService.post(BaseURL+'create', { customer_id: customer_id, duplicate_id: duplicate_id });
    }
}
